import React from "react"
import { OldButton } from "@kit/design/old-button"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { ColorInput } from "@kit/design/color-picker"
import SocialIcon from "@kit/design/social-icon"
import SelectMenu from "@kit/design/select-menu"
import Label from "@kit/design/label"
import { handleDelete } from "../setting-utils"
import { useSavedColors } from "hooks/use-saved-colors"

const MOCKUPS = {
  ICON_ONLY: (
    <SocialIcon
      name="twitter"
      style={{ color: "#0c85d0", width: 20, height: 20 }}
    />
  ),
  CIRCLE: (
    <SocialIcon
      name="twitter"
      style={{
        background: "#0c85d0",
        color: "#fff",
        width: 20,
        height: 20,
        padding: 4
      }}
      className="rounded-full"
    />
  ),
  SQUARE: (
    <SocialIcon
      name="twitter"
      style={{
        background: "#0c85d0",
        color: "#fff",
        width: 20,
        height: 20,
        padding: 4
      }}
      className="rounded"
    />
  )
}

export function IconsSettings({ block_id }) {
  const { properties, update, remove } = useBlocks(block_id)

  const usingCustomColors = properties.foreground && properties.background
  const usingBackground = properties.shape !== "icon-only"

  const savedColors = useSavedColors()

  const handleRemove = () => handleDelete(block_id, remove, "icon collection")

  const resetColors = e => {
    if (e.target.value === "platform") {
      update({ background: null, foreground: null })
    } else {
      update({ background: "#44b1ff", foreground: "#ffffff" })
    }
  }

  return (
    <div className="px-4 pb-4">
      <div className="mb-4">
        <Label>Icon style</Label>
        <div className="grid grid-cols-3 gap-4">
          <RadioButtonOption
            text="Square"
            onClick={() => update({ shape: "square" })}
            active={properties.shape === "square"}
            icon={MOCKUPS.SQUARE}
          />
          <RadioButtonOption
            text="Circle"
            onClick={() => update({ shape: "circle" })}
            active={properties.shape === "circle"}
            icon={MOCKUPS.CIRCLE}
          />
          <RadioButtonOption
            text="Icon only"
            onClick={() => update({ shape: "icon-only" })}
            active={properties.shape === "icon-only"}
            icon={MOCKUPS.ICON_ONLY}
          />
        </div>
      </div>
      <div className="mb-4">
        <Label htmlFor="color_style">Icon color</Label>
        <SelectMenu
          label="Icon color style"
          id="color_style"
          onChange={resetColors}
          value={usingCustomColors ? "custom" : "platform"}
          className="w-full"
          options={[
            { label: "Platform Color", value: "platform" },
            { label: "Custom Color", value: "custom" }
          ]}
        />
      </div>
      {usingCustomColors && (
        <>
          <div className="mb-4">
            <Label id="foreground">Foreground color</Label>
            <ColorInput
              name="foreground"
              id="foreground"
              value={properties.foreground}
              onChange={color => update({ foreground: color.hex })}
              savedColors={savedColors}
            />
          </div>

          {usingBackground && (
            <div className="mb-4">
              <Label htmlFor="background">Background color</Label>
              <ColorInput
                name="background"
                id="background"
                value={properties.background}
                onChange={color => update({ background: color.hex })}
                savedColors={savedColors}
              />
            </div>
          )}
        </>
      )}
      <div className="mb-4">
        <Label htmlFor="alignment">Icon alignment</Label>
        <SelectMenu
          label="Alignment"
          id="alignment"
          onChange={e => update({ alignment: e.target.value })}
          value={properties.alignment}
          className="w-full"
          options={[
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" }
          ]}
        />
      </div>
      <OldButton
        size="sm"
        is="secondary"
        className="ml-auto block"
        onClick={handleRemove}
        icon="delete"
      >
        Remove icons
      </OldButton>
    </div>
  )
}

function RadioButtonOption({ icon, text, active, onClick, className }) {
  const activeClasses = active ? "border-blue-500" : "border-transparent"
  const classNames = `rounded pt-3 pb-2 border-2 bg-gray-50 ${className} ${activeClasses}`

  return (
    <button onClick={onClick} className={classNames}>
      <div className="mb-2">{icon}</div>
      <div className="leading-none text-xs">{text}</div>
    </button>
  )
}
